import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pit",
  "use": "icon-pit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pit\"><path d=\"M54.857143 812.434286h877.714286v73.142857H54.857143zM224.182857 704c4.754286 15.177143 18.834286 25.6 34.925714 25.6h469.394286c16.091429 0 30.171429-10.422857 34.925714-25.6l167.68-536.32c3.474286-11.154286 1.462857-23.222857-5.485714-32.548571s-17.92-14.994286-29.622857-14.994286h-167.68c-15.542857 0-29.44 9.874286-34.56 24.502857l-125.622857 360.228571h-149.211429l-125.622857-360.228571c-5.12-14.628571-19.017143-24.502857-34.56-24.502857H91.428571c-11.702857 0-22.491429 5.485714-29.44 14.994286s-8.96 21.394286-5.485714 32.365714l167.68 536.502857z m8.96-510.72l125.622857 360.228571c5.12 14.628571 19.017143 24.502857 34.56 24.502858h201.142857c15.542857 0 29.44-9.874286 34.56-24.502858l125.622858-360.228571h91.977142L701.44 656.457143H285.988571L141.165714 193.28h91.977143z\" p-id=\"92573\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pit.svg
// module id = 4fgE
// module chunks = 215